const ChevronDown = (props:any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 10.875 6.062 6.937 5 8l5 5 5-5-1.063-1.063L10 10.876Z"
    />
  </svg>
)
export default ChevronDown
